import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";
import {
  ConfigQrCodePortaForm,
  GeolocalizacaoPortaForm,
  LogGeolocalizacaoPorta,
  LogQrCodePorta,
  LogReplicacaoPorta,
  PortaEquipamentoPac,
  PortaEquipamentoPacForm,
  ReplicarConfigPorta
} from "app/pages/full-pages/equipamento-pac/equipamento-pac.models";

export abstract class AbPortaEquipamentoPac extends AppService {
  abstract prefixo: string;

  abstract listarPortas(equipamentoId: number): Observable<PortaEquipamentoPac[]>;
  abstract buscarPorta(equipamentoId: number, portaId: number): Observable<PortaEquipamentoPac>;
  abstract salvar(equipamentoId: number, portaId: number, form: PortaEquipamentoPacForm): Observable<PortaEquipamentoPac>;
  abstract alterarStatus(equipamentoId: number, portaId: number, ativa: boolean): Observable<PortaEquipamentoPac>;
  abstract replicar(equipamentoId: number, dto: ReplicarConfigPorta): Observable<PortaEquipamentoPac[]>;
  abstract listarLogReplicacao(equipamentoId: number): Observable<LogReplicacaoPorta[]>;
  abstract salvarGeolocalizacao(equipamentoId: number, form: GeolocalizacaoPortaForm): Observable<PortaEquipamentoPac>;
  abstract listarLogGeolocalizacao(equipamentoId: number): Observable<LogGeolocalizacaoPorta[]>;
  abstract salvarConfigQrCode(equipamentoId: number, form: ConfigQrCodePortaForm): Observable<PortaEquipamentoPac>;
  abstract listarLogQrCode(equipamentoId: number): Observable<LogQrCodePorta[]>;
}
